module.exports = __webpack_public_path__ + "img/004.bac4d7c5.png";